import { StatusBadge, type StatusTone } from "@/components/status-badge";

/**
 * Payment method codes that map to AcceptedOnInvoicePdf = true in the
 * admin lookup.  Kept as a union so call-sites get autocomplete; the component
 * also accepts arbitrary strings for unknown/future codes.
 */
export type PaymentMethodCode =
  | "BPay"
  | "CreditCard"
  | "DirectDebit"
  | "EFT"
  | "Cash"
  | "Cheque"
  | string;

const tone: Record<string, StatusTone> = {
  BPay:        "info",
  CreditCard:  "success",
  DirectDebit: "success",
  EFT:         "info",
  Cash:        "warning",
  Cheque:      "warning",
};

const label: Record<string, string> = {
  BPay:        "BPay",
  CreditCard:  "Credit card",
  DirectDebit: "Direct debit",
  EFT:         "EFT",
  Cash:        "Cash",
  Cheque:      "Cheque",
};

export interface PaymentMethodBadgeProps {
  code: PaymentMethodCode;
  /**
   * When true the method is highlighted with a bolder colour (matches the
   * AcceptedOnInvoicePdf=true concept — these are the preferred methods).
   */
  acceptedOnPdf?: boolean;
}

export function PaymentMethodBadge({ code, acceptedOnPdf }: PaymentMethodBadgeProps) {
  const resolvedTone: StatusTone = acceptedOnPdf
    ? "success"
    : (tone[code] ?? "neutral");
  const resolvedLabel = label[code] ?? code;
  return <StatusBadge tone={resolvedTone}>{resolvedLabel}</StatusBadge>;
}
